import styled from 'styled-components';

export const TitleWrapper = styled.div<{width?: string}>`
  width: ${(props) => props.width || "315px"};;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const PopOverWrap = styled.div`
  cursor: pointer;
`

export const AddressInforWrapper = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;